import React, { Fragment } from 'react'
import _ from 'lodash'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
//import EventEmitter from 'react-native-md5'
import 'bootstrap/dist/css/bootstrap.min.css'
//const Functions = require('../../shared/Functions.js')
//const $ = require('jquery')

const tableStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '25px',
}

const aStyle = {
  display: 'none',
}

class Table extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpenedSent: false,
    }
  }

  handleCancel(idR) {
    //console.log(idR)
    const urlf = '/api/v1/requests/' + idR.toString()
    const meth = 'DELETE'
    fetch(urlf, {
      method: meth,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => response.json())
    .then(() => {
      document.getElementById('mylink').click()
    })
    .catch((err) => {
      console.error('Error while cancelling request! ' + err)
    })
  }

  handleRespond(idR, response) {
    const urlf = '/api/v1/requests/' + idR.toString()
    const meth = 'PUT'
    const body = JSON.stringify({response: response})
    fetch(urlf, {
      method: meth,
      headers: {
        'Content-Type': 'application/json',
      },
      body: body,
    })
    .then(response => response.json())
    .then(() => {
      document.getElementById('mylink').click()
    })
    .catch((err) => {
      console.error('Error while responding to request! ' + err)
    })
  }

  renderHeader() {
    return <Fragment><th key="request">Request</th><th key="type">Type</th><th key="date">Date</th><th key="action">Actions</th></Fragment>
  }

  renderHeaderAcc() {
    return <Fragment><th key="accounting" colSpan="5">Accounting</th></Fragment>
  }

  renderData() {
    if (_.size(this.props.requests.requests.sent_accounting) > 0){
      const myData = [].concat(Object.values(this.props.requests.requests.sent_accounting))
      return Object.keys(myData).map((key) => {
        const request = myData[key]
        const idR = request['id']
        return <tr key={key}><td>{request['accepted'] === true ? 'Cancel time off' : 'Take time off'}</td><td>{request['type']}</td><td>{request['start_date']} to {request['end_date']}</td><td><div className="btn btn-secondary btn-sm btn-block" onClick={() => this.handleCancel(idR)}>Cancel request</div></td></tr>
      }
      )
    } else {
      return <tr key="none"><td colSpan="5">You do not have any requests!</td></tr>
    }
  }

  renderHeaderCall() {
    return <Fragment><th key="request2">Request</th><th key="team">Team</th><th key="dates">Dates</th><th key="action2">Actions</th></Fragment>
  }

  renderHeaderOncall() {
    return <Fragment><th key="oncall" colSpan="5">OnCall Scheduler</th></Fragment>
  }

  renderDataOncall() {
    if (_.size(this.props.requests.requests.sent_oncall) > 0){
      const myData = [].concat(Object.values(this.props.requests.requests.sent_oncall))
      return Object.keys(myData).map((key) => {
        const request = myData[key]
        const color = request['team_color']
        const idR = request['id']
        return <tr key={key}><td>Swap</td><td>{request['team_name']}<div className="mini-box bd-placeholder-img rounded" style={{backgroundColor: color }}></div></td><td>{request['old_date']} with {request['new_date']}</td><td><div className="btn btn-secondary btn-sm btn-block" onClick={() => this.handleCancel(idR)}>Cancel request</div></td></tr>
      }
      )
    } else {
      return <tr key="none"><td colSpan="5">You do not have any requests!</td></tr>
    }
  }

  renderHeaderRAcco() {
    return <Fragment><th key="user">User</th><th key="manager">Manager</th><th key="request3">Request</th><th key="type2">Type</th><th key="date2">Date</th><th key="action3" colSpan="2">Actions</th></Fragment>
  }

  renderHeaderRAcc() {
    return <Fragment><th key="accounting2" colSpan="6">Accounting</th></Fragment>
  }

  renderDataRAcc() {
    if (_.size(this.props.requests.requests.received_accounting) > 0){
      const myData = [].concat(Object.values(this.props.requests.requests.received_accounting))
      return Object.keys(myData).map((key) => {
        const request = myData[key]
        const idR = request['id']
        return <tr key={key}><td>{request['user_name']}</td><td>{request['manager_name']}</td><td>{request['accepted'] === true ? 'Cancel time off' : 'Take time off'}</td><td>{request['type']}</td><td style={{ width: '150px'}}>{request['start_date']} to {request['end_date']}</td><td colSpan="2"><div className="btn btn-success btn-sm col-sm-5" onClick={() => this.handleRespond(idR, 'accept')}>Accept</div><div className="btn btn-danger btn-sm col-sm-5 offset-sm-1" onClick={() => this.handleRespond(idR, 'decline')}>Decline</div></td></tr>
      }
      )
    } else {
      return <tr key="none"><td colSpan="6">You do not have any requests!</td></tr>
    }
  }

  renderHeaderROncall() {
    return <Fragment><th key="user2">User</th><th key="request4">Request</th><th key="team2">Team</th><th key="dates2">Dates</th><th key="action4" colSpan="2">Actions</th></Fragment>
  }

  renderHeaderROn() {
    return <Fragment><th key="sched" colSpan="6">OnCall Scheduler</th></Fragment>
  }

  renderDataROncall() {
    if (_.size(this.props.requests.requests.received_oncall) > 0){
      const myData = [].concat(Object.values(this.props.requests.requests.received_oncall))
      return Object.keys(myData).map((key) => {
        const request = myData[key]
        const color = request['team_color']
        const idR = request['id']
        return <tr key={key}><td>{request['user_name']}</td><td>Swap</td><td>{request['team_name']}<div className="mini-box bd-placeholder-img rounded" style={{backgroundColor: color }}></div></td><td>{request['old_date']} with {request['new_date']}</td><td colSpan="2"><div className="btn btn-success btn-sm col-sm-4" onClick={() => this.handleRespond(idR, 'accept')}>Accept</div><div className="btn btn-danger btn-sm col-sm-4 offset-sm-1" onClick={() => this.handleRespond(idR, 'decline')}>Decline</div></td></tr>
      }
      )
    } else {
      return <tr key="none"><td colSpan="6">You do not have any requests!</td></tr>
    }
  }

  renderHeaderApp() {
    return <Fragment><th key="approved" colSpan="6">Account Approval</th></Fragment>
  }

  renderHeaderApp2() {
    return <Fragment><th key="usera">User</th><th key="requesta">Request</th><th key="emaila">Email</th><th key="linka">See details</th><th key="actiona" colSpan="2">Actions</th></Fragment>
  }

  renderDataApp() {
    if (_.size(this.props.requests.requests.received_approve) > 0){
      const myData = [].concat(Object.values(this.props.requests.requests.received_approve))
      return Object.keys(myData).map((key) => {
        const request = myData[key]
        const idR = request['id']
        const ref = '/employee_details/' + request['user_id']
        return <tr key={key}><td>{request['user_name']}</td><td>Account approval</td><td>{request['user_email']}</td><td><a href={ref}>{request['user_name']}</a></td><td colSpan="2"><div className="btn btn-success btn-sm col-sm-4" onClick={() => this.handleRespond(idR, 'accept')}>Accept</div><div className="btn btn-danger btn-sm col-sm-4 offset-sm-1" onClick={() => this.handleRespond(idR, 'decline')}>Decline</div></td></tr>
      }
      )
    } else {
      return <tr key="none"><td colSpan="6">You do not have any requests!</td></tr>
    }
  }

  render() {
    return <div className="col-md-12"><a href="/requests" style={aStyle} id="mylink"></a><div style={{ fontSize: '30px', paddingBottom: '10px'}}><a href="#" style={{ color: 'black', fontWeight: !this.state.isOpenedSent ? 'bold' : 'normal'}} onClick={ () => this.setState(oldState => ({ isOpenedSent: !oldState.isOpenedSent }))}>Received Requests</a><span style={{ paddingLeft: '10px', paddingRight: '10px'}}>|</span><a href="#" style={{ color: 'black', fontWeight: this.state.isOpenedSent ? 'bold' : 'normal'}} onClick={ () => this.setState(oldState => ({ isOpenedSent: !oldState.isOpenedSent }))}>Sent Requests</a></div><div className="justify-content-center align-items-center" style={{ display: this.state.isOpenedSent ? 'block' : 'none'}}><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeaderAcc()}</tr><tr>{this.renderHeader()}</tr>{this.renderData()}</tbody></table></div><div className="justify-content-center align-items-center" style={{ display: this.state.isOpenedSent ? 'block' : 'none'}}><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeaderOncall()}</tr><tr>{this.renderHeaderCall()}</tr>{this.renderDataOncall()}</tbody></table></div><div className="justify-content-center align-items-center" style={{ display: !this.state.isOpenedSent ? 'block' : 'none'}}><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeaderRAcc()}</tr><tr>{this.renderHeaderRAcco()}</tr>{this.renderDataRAcc()}</tbody></table></div><div className="justify-content-center align-items-center" style={{ display: !this.state.isOpenedSent ? 'block' : 'none'}}><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeaderROn()}</tr><tr>{this.renderHeaderROncall()}</tr>{this.renderDataROncall()}</tbody></table></div><div className="justify-content-center align-items-center" style={{ display: !this.state.isOpenedSent ? 'block' : 'none'}}><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeaderApp()}</tr><tr>{this.renderHeaderApp2()}</tr>{this.renderDataApp()}</tbody></table></div></div>
  }
}

Table.propTypes = {
  requests: PropTypes.object,
}

export default Table
